import React, { useEffect, useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
  //   additionalActions,
} from "@screens/inventory/inventory-items/inventory-item-list/model/item-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
  getParamsData,
} from "@utils/filters.util";
import { APP, PRIMARY_KEY } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";

import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import {
  deleteDataApi,
  downloadSampleFile,
  downloadSampleFileWithoutSpecs,
  getDataApi,
  getManufacturesDataApi,
  readFile,
} from "./item-list.component.service";
import InventoryItemListTemplateComponent from "./item-list-template.component";
import { getInventoryFileUploadInputs } from "@screens/common/inventory-file-upload/inventory-file-upload.modal";
import { getCategories } from "../inventory-item-create/item-create.component.service";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ITEM_ALERTS: { DELETE_ALERT },
  FILE_UPLOAD_ALERT: { FILE_UPLOAD_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const InventoryItemListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const tableParams = getParamsData(filterList, menuUrl);
  const { appRowsPerPage } = useSelector((state) => state.app);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [hideFooter, setHideFooter] = useState(false);
  const [filterState, setFilterState] = useState(filters);
  const [uploadFormData, setUploadFormData] = useState([
    { name: "category_id", value: "" },
    { name: "file", value: null },
  ]);
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
    loading: true,
  });
  const [formInputs, setFormInputs] = useState([]);
  const [openUploadModalWithoutSpecs, setOpenUploadModalWithoutSpecs] =
    useState(false);

  const getInventoryItemsData = async (params = null) => {
    console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const versionData = await getDataApi({
      ...params,
      filters: queryStr,
    });
    if (versionData.status) {
      console.log(versionData);
      setTableData(versionData.data);
      setTotalCount(versionData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 }),
        );
        getInventoryItemsData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: appRowsPerPage || ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({
            type: ERROR,
            message: response.message,
            viewed: 0,
          }),
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        }),
      );
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    console.log({ queryStr });
    getInventoryItemsData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: appRowsPerPage || ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  const handleUploadClickwithoutspecs = () => {
    setOpenUploadModalWithoutSpecs(true);
  };

  const handleUploadClick = () => {
    setOpenUploadModal(true);
  };

  const handleUploadSubmit = async () => {
    setHideFooter(true);
    const payload = {};
    uploadFormData.forEach((field) => {
      payload[field.name] = field.value;
    });

    const response = await readFile(payload);

    if (response.status) {
      setOpenUploadModal(false);
      setOpenUploadModalWithoutSpecs(false);
      setUploadFormData([
        { name: "category_id", value: "" },
        { name: "file", value: null },
      ]);

      await getInventoryItemsData({
        orderBy: "created_at",
        sortBy: "desc",
        skip: 0,
        limit: appRowsPerPage || ROWS_PER_PAGE,
      });

      dispatch(setAlertMessage({ type: SUCCESS, message: FILE_UPLOAD_ALERT }));
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
    setHideFooter(false);
  };

  const handleFieldChange = (fieldName, value) => {
    setUploadFormData((prev) =>
      prev.map((f) => (f.name === fieldName ? { ...f, value } : f)),
    );
  };

  const handleDownloadSample = async () => {
    const categoryField = uploadFormData.find((f) => f.name === "category_id");

    if (!categoryField?.value) {
      alert("Please select a category first.");
      return;
    }

    const payload = {
      inventory_category_id: categoryField.value,
    };

    const response = await downloadSampleFile(payload);

    if (response.status) {
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "inventory_sample.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } else {
      alert(response.message || "Download failed");
    }
  };

  const handleDownloadSampleWithoutSpecs = async () => {
    const categoryField = uploadFormData.find((f) => f.name === "category_id");

    if (!categoryField?.value) {
      alert("Please select a category first.");
      return;
    }

    const payload = {
      inventory_category_id: categoryField.value,
    };

    const response = await downloadSampleFileWithoutSpecs(payload);

    if (response.status) {
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "inventory-sample-without-specs.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } else {
      alert(response.message || "Download failed");
    }
  };

  const handleUploadCancel = () => {
    const clearedFormData = uploadFormData?.map((field) => {
      if (field.name === "file" || field.name === "category_id") {
        return { ...field, value: null };
      }
      return field;
    });

    setUploadFormData(clearedFormData);
    setOpenUploadModal(false);
    setOpenUploadModalWithoutSpecs(false);
  };

  const onLoad = async () => {
    const categoryResponse = await getCategories();
    // console.log({ categoryResponse });

    if (categoryResponse.status) {
      const formattedCategories = categoryResponse.data.map((cat) => ({
        name: cat.name,
        value: cat.id,
      }));
      setCategories(formattedCategories);
      setFormInputs(getInventoryFileUploadInputs(formattedCategories));
      setFormTriggers({ ...formTriggers, loading: false });
    }

    const manufacturerResponse = await getManufacturesDataApi();

    if (manufacturerResponse.status) {
      const formattedManufacturers =
        manufacturerResponse.data.manufacturers.map((make) => ({
          name: make.manufacturer_name,
          // value: make.id,
        }));
      setManufacturers(formattedManufacturers);
      setFormInputs(getInventoryFileUploadInputs(formattedManufacturers));
      setFormTriggers({ ...formTriggers, loading: false });

      const manufacturerFilters = rawFilters({
        manufacturers: formattedManufacturers || [],
      });
      setFilterState(manufacturerFilters);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);
  console.log({ hideFooter });

  return menuAccess ? (
    <InventoryItemListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filterState,
        tableParams,
        openUploadModal,
        categories,
        formInputs,
        formTriggers,
        uploadFormData,
        hideFooter,
        openUploadModalWithoutSpecs,
      }}
      templateEvents={{
        getInventoryItemsData,
        handleCreateClick,
        deleteRecords,
        submitFilter,
        handleUploadClick,
        handleUploadSubmit,
        handleUploadCancel,
        handleFieldChange,
        handleDownloadSample,
        handleDownloadSampleWithoutSpecs,
        handleUploadClickwithoutspecs,
      }}
    />
  ) : (
    <> </>
  );
};

export default InventoryItemListComponent;
